import {Injectable}     from 'angular2/core';
import {Http} from 'angular2/http';
import {Observable}     from 'rxjs/Observable';
import {App} from "../../app_config";
import {Country} from "../../models/country.model";

@Injectable()
export class CountryService {

    constructor(private http:Http) {
    }

    private _countryUrl = App.AppConfig.apiEndPoint + '/countries/';

    getCountries():Observable<Country[]> {
        return this.http.get(this._countryUrl)
            .map(response => response.json().countries)
            .map(countries => countries.map(country => new Country(country)))
            .catch(this.handleError);
    }

    private handleError(error:any) {
        // In a real world app, we might send the error to remote logging infrastructure
        let errMsg = error.message || 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }
}
